export default __webpack_public_path__ + "static/media/mc-logo-wide-white.337d1ff4.svg";